import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { store } from '../../../../../app/store'
import { BusinessProvinceMap } from '../../../../companyAnalysis/industry/industryOverview/businessProvince/BusinessProvinceMap'
import { BusinessProvinceTable } from '../../../../companyAnalysis/industry/industryOverview/businessProvince/BusinessProvinceTable'
import { getBusinessProvinceTable } from '../../../../companyAnalysis/industry/industryOverview/businessProvince/store/thunk'
import { BusinessSizeTable } from '../../../../companyAnalysis/industry/industryOverview/businessSize/BusinessSizeTable'
import { BusinessSizePieChart } from '../../../../companyAnalysis/industry/industryOverview/businessSize/pieChart'
import { getBusinessSizeTable } from '../../../../companyAnalysis/industry/industryOverview/businessSize/store/thunk'
import { BusinessStatusTable } from '../../../../companyAnalysis/industry/industryOverview/businessStatus/BusinessStatusTable'
import { BusinessStatusPieChart } from '../../../../companyAnalysis/industry/industryOverview/businessStatus/pieChart'
import { getBusinessOperatingStatusTable } from '../../../../companyAnalysis/industry/industryOverview/businessStatus/store/thunk'
import { BusinessYearsTable } from '../../../../companyAnalysis/industry/industryOverview/businessYears/BusinessYearsTable'
import { BusinessYearsPieChart } from '../../../../companyAnalysis/industry/industryOverview/businessYears/pieChart'
import { getBusinessYearsTable } from '../../../../companyAnalysis/industry/industryOverview/businessYears/store/thunk'
import { IndustryScaleTable } from '../../../../companyAnalysis/industry/industryOverview/industryScale/IndustryScaleTable'
import { getIndustryScaleTable } from '../../../../companyAnalysis/industry/industryOverview/industryScale/store/thunk'
import {
  GDP_TAB,
  IMPORT_EXPORT_TAB,
} from '../../../../companyAnalysis/industry/industryOverview/macroeconomics/constant'
import { FdiTable } from '../../../../companyAnalysis/industry/industryOverview/macroeconomics/fdi/fdiTable'
import { getFdiData } from '../../../../companyAnalysis/industry/industryOverview/macroeconomics/fdi/store/thunk'
import { GDPTableContent } from '../../../../companyAnalysis/industry/industryOverview/macroeconomics/gdp/gdpTable/GDPTableContent'
import { selectMacroGDPTable } from '../../../../companyAnalysis/industry/industryOverview/macroeconomics/gdp/gdpTable/slice'
import {
  getNominalGDP,
  getRealGDP,
} from '../../../../companyAnalysis/industry/industryOverview/macroeconomics/gdp/store/thunk'
import { getImportExportData } from '../../../../companyAnalysis/industry/industryOverview/macroeconomics/importExport/store/thunk'
import { ImportExportTableContent } from '../../../../companyAnalysis/industry/industryOverview/macroeconomics/importExport/table/ImportExportTableContent'
import { selectMacroImportExportTable } from '../../../../companyAnalysis/industry/industryOverview/macroeconomics/importExport/table/slice'
import { FiscalYearListRadio } from '../../../../companyAnalysis/industry/industryOverview/topIndustryPlayers/FiscalYearListRadio'
import { TopPlayerTableContent } from '../../../../companyAnalysis/industry/industryOverview/topIndustryPlayers/TopPlayerTableContent'
import {
  RANK_BY,
  TOP_COMPANY,
} from '../../../../companyAnalysis/industry/industryOverview/topIndustryPlayers/constant'
import { selectTopIndustryPlayersState } from '../../../../companyAnalysis/industry/industryOverview/topIndustryPlayers/store/slice'
import { getTopPlayersTable } from '../../../../companyAnalysis/industry/industryOverview/topIndustryPlayers/store/thunk'
import { getUnique } from '../../../../helpers/common'
import { COMPANY_TYPES } from '../../../../utils/common'
import {
  MAIN_SCREEN,
  SCREEN,
  TYPE_INFORMATION_PANEL,
  TYPE_ITEM_SETTING,
  VIEW_BY,
} from '../../constant'
import ItemRadio from '../../preferenceSetting/detailTemplate/settingPanel/information/ItemRadio'
import { selectCompanyType } from '../../preferenceSetting/detailTemplate/store/slice'
import { mapThunkCommon } from '../thunkCommon'

export const PANELS = {
  MACROECONOMICS_GDP: 'macroeconomicsGDP',
  MACROECONOMICS_FDI: 'macroeconomicsFDI',
  MACROECONOMICS_IMPORT_EXPORT: 'macroeconomicsImportExport',
  TOP_INDUSTRY_PLAYERS: 'topIndustryPlayers',
  BUSINESS_ALLOCATION_BY_SIZE: 'businessAllocationBySize',
  BUSINESS_ALLOCATION_BY_AGE: 'businessAllocationByAge',
  BUSINESS_ALLOCATION_BY_OPERATING_STATUS:
    'businessAllocationByOperatingStatus',
  BUSINESS_ALLOCATION_BY_PROVINCE: 'businessAllocationByProvince',
  INDUSTRY_SCALE: 'industryScale',
}

export const getPanelListIndustryOverview = () => {
  return [
    {
      label: 'dynamicReport.INDUSTRY_OVERVIEW',
      children: [
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_OVERVIEW,
          panel: PANELS.INDUSTRY_SCALE,
          label: 'dynamicReport.INDUSTRY_SCALE',
          type: TYPE_ITEM_SETTING.PANEL,
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_OVERVIEW,
          panel: PANELS.MACROECONOMICS_GDP,
          label: 'dynamicReport.MACROECONOMICS_GDP',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            isRealGDP: true,
            column: 'VALUE',
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_OVERVIEW,
          panel: PANELS.MACROECONOMICS_FDI,
          label: 'dynamicReport.MACROECONOMICS_FDI',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            column: 'VALUE',
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_OVERVIEW,
          panel: PANELS.MACROECONOMICS_IMPORT_EXPORT,
          label: 'dynamicReport.MACROECONOMICS_IMPORT_EXPORT',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            isGrowthRate: true,
            column: 'EXPORT',
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_OVERVIEW,
          panel: PANELS.TOP_INDUSTRY_PLAYERS,
          label: 'dynamicReport.TOP_INDUSTRY_PLAYERS',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            top: TOP_COMPANY.top10.value,
            fiscalYear: undefined,
            isRankByTotalAssets: true,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_OVERVIEW,
          panel: PANELS.BUSINESS_ALLOCATION_BY_SIZE,
          label: 'dynamicReport.BUSINESS_ALLOCATION_BY_SIZE',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.TABLE,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_OVERVIEW,
          panel: PANELS.BUSINESS_ALLOCATION_BY_AGE,
          label: 'dynamicReport.BUSINESS_ALLOCATION_BY_AGE',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.TABLE,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_OVERVIEW,
          panel: PANELS.BUSINESS_ALLOCATION_BY_OPERATING_STATUS,
          label: 'dynamicReport.BUSINESS_ALLOCATION_BY_OPERATING_STATUS',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.TABLE,
          },
        },
        {
          screen: SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].INDUSTRY_OVERVIEW,
          panel: PANELS.BUSINESS_ALLOCATION_BY_PROVINCE,
          label: 'dynamicReport.BUSINESS_ALLOCATION_BY_PROVINCE',
          type: TYPE_ITEM_SETTING.PANEL,
          setting: {
            viewBy: VIEW_BY.TABLE,
          },
        },
      ],
    },
  ]
}

export const getPanelIndustryOverview = (
  panel,
  {
    viewBy,
    column,
    top,
    fiscalYear,
    isRankByTotalAssets,
    isRealGDP,
    isGrowthRate,
  },
) => {
  switch (panel) {
    case PANELS.MACROECONOMICS_GDP:
      return {
        renderComponent: () => {
          return (
            <GDPTableContent
              isDynamicReport
              column={column}
              tab={isRealGDP ? GDP_TAB.REAL_GDP.key : GDP_TAB.NOMINAL_GDP.key}
            />
          )
        },
        width: 950,
        dependThunks: [mapThunkCommon.ALL_VSICS],
        thunk: [
          ({ companyInfo = {} }) =>
            isRealGDP
              ? getRealGDP({
                  OrganizationId: companyInfo.organizationId,
                })
              : getNominalGDP({
                  OrganizationId: companyInfo.organizationId,
                }),
        ],
        isWaitForMount: true,
        isTable: true,
        settingPanel: {
          items: [
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'isRealGDP',
              value: true,
              title: 'industryOverview.macroeconomics.REAL_GDP',
              isInline: true,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'VALUE',
                  title: 'industryOverview.macroeconomics.VALUE',
                },
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'CONTRIBUTION_PERCENT',
                  title: 'industryOverview.macroeconomics.CONTRIBUTION_PERCENT',
                },
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'GROWTH_RATE_PERCENT',
                  title: 'industryOverview.macroeconomics.GROWTH_RATE_PERCENT',
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'isRealGDP',
              value: false,
              title: 'industryOverview.macroeconomics.NOMINAL_GDP',
              isInline: true,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'VALUE',
                  title: 'industryOverview.macroeconomics.VALUE',
                },
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'CONTRIBUTION_PERCENT',
                  title: 'industryOverview.macroeconomics.CONTRIBUTION_PERCENT',
                },
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'GROWTH_RATE_PERCENT',
                  title: 'industryOverview.macroeconomics.GROWTH_RATE_PERCENT',
                },
              ],
            },
          ],
        },
      }
    case PANELS.MACROECONOMICS_FDI:
      return {
        renderComponent: () => {
          return <FdiTable isDynamicReport column={column} />
        },
        width: 950,
        dependThunks: [mapThunkCommon.ALL_VSICS],
        thunk: [
          ({ companyInfo = {} }) =>
            getFdiData({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
        settingPanel: {
          isInline: true,
          items: [
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'column',
              value: 'VALUE',
              title: 'industryOverview.macroeconomics.VALUE',
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'column',
              value: 'CONTRIBUTION_PERCENT',
              title: 'industryOverview.macroeconomics.CONTRIBUTION_PERCENT',
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'column',
              value: 'GROWTH_RATE_PERCENT',
              title: 'industryOverview.macroeconomics.GROWTH_RATE_PERCENT',
            },
          ],
        },
      }
    case PANELS.MACROECONOMICS_IMPORT_EXPORT:
      return {
        renderComponent: () => {
          return (
            <ImportExportTableContent
              tab={
                isGrowthRate
                  ? IMPORT_EXPORT_TAB.GROWTH_RATE_PERCENT.key
                  : IMPORT_EXPORT_TAB.VALUE.key
              }
              isDynamicReport
              column={column}
            />
          )
        },
        width: 950,
        dependThunks: [mapThunkCommon.ALL_VSICS],
        thunk: [
          ({ companyInfo = {} }) =>
            getImportExportData({
              OrganizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
        settingPanel: {
          items: [
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'isGrowthRate',
              value: true,
              title: 'industryOverview.macroeconomics.GROWTH_RATE',
              isInline: true,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'EXPORT',
                  title: 'industryOverview.macroeconomics.EXPORT',
                },
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'IMPORT',
                  title: 'industryOverview.macroeconomics.IMPORT',
                },
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'BALANCE_OF_TRADE',
                  title: 'industryOverview.macroeconomics.BALANCE_OF_TRADE',
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.RADIO,
              key: 'isGrowthRate',
              value: false,
              title: 'industryOverview.macroeconomics.VALUE',
              isInline: true,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'EXPORT',
                  title: 'industryOverview.macroeconomics.EXPORT',
                },
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'IMPORT',
                  title: 'industryOverview.macroeconomics.IMPORT',
                },
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'column',
                  value: 'BALANCE_OF_TRADE',
                  title: 'industryOverview.macroeconomics.BALANCE_OF_TRADE',
                },
              ],
            },
          ],
        },
      }
    case PANELS.TOP_INDUSTRY_PLAYERS:
      return {
        renderComponent: () => {
          return <TopPlayerTableContent isDynamicReport />
        },
        thunk: [
          ({ companyInfo = {} }) =>
            getTopPlayersTable({
              OrganizationId: companyInfo.organizationId,
              Top: top,
              Year: fiscalYear,
              SortByAssets: isRankByTotalAssets,
              SortByRevenue: !isRankByTotalAssets,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
        settingPanel: {
          items: [
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <>
                  <Translate value="Top" />:
                </>
              ),
              isInline: true,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'top',
                  value: TOP_COMPANY.top10.value,
                  title: TOP_COMPANY.top10.label,
                },
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'top',
                  value: TOP_COMPANY.top50.value,
                  title: TOP_COMPANY.top50.label,
                },
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'top',
                  value: TOP_COMPANY.top100.value,
                  title: TOP_COMPANY.top100.label,
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <>
                  <Translate value="common.FISCAL_YEAR" />:
                </>
              ),
              isInline: true,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  key: 'fiscalYear',
                  renderItem: (props) => {
                    return (
                      <FiscalYearListRadio {...props} keySetting={props.key}>
                        {(others) => {
                          return (
                            <ItemRadio
                              isI18n={false}
                              keySetting={props.key}
                              {...props}
                              {...others}
                            />
                          )
                        }}
                      </FiscalYearListRadio>
                    )
                  },
                },
              ],
            },
            {
              type: TYPE_INFORMATION_PANEL.NODE,
              renderItem: () => (
                <Translate value="industryOverview.topIndustryPlayers.RANK_BY" />
              ),
              isInline: true,
              children: [
                {
                  type: TYPE_INFORMATION_PANEL.RADIO,
                  key: 'isRankByTotalAssets',
                  value: true,
                  title: RANK_BY.totalAssets.label,
                },
                {
                  type: TYPE_INFORMATION_PANEL.NODE,
                  key: 'isRankByTotalAssets',
                  renderItem: (props) => {
                    return (
                      <RankByItem
                        isI18n
                        value={false}
                        keySetting={props.key}
                        {...props}
                      />
                    )
                  },
                },
              ],
            },
          ],
        },
      }
    case PANELS.BUSINESS_ALLOCATION_BY_SIZE:
      return {
        renderComponent: () => {
          return viewBy === VIEW_BY.TABLE ? (
            <BusinessSizeTable isDynamicReport />
          ) : (
            <BusinessSizePieChart isDynamicReport />
          )
        },
        thunk: [
          ({ companyInfo }) =>
            getBusinessSizeTable({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: viewBy === VIEW_BY.TABLE,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.CHART],
        },
      }
    case PANELS.BUSINESS_ALLOCATION_BY_AGE:
      return {
        renderComponent: () => {
          return viewBy === VIEW_BY.TABLE ? (
            <BusinessYearsTable isDynamicReport />
          ) : (
            <BusinessYearsPieChart isDynamicReport />
          )
        },
        thunk: [
          ({ companyInfo }) =>
            getBusinessYearsTable({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: viewBy === VIEW_BY.TABLE,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.CHART],
        },
      }
    case PANELS.BUSINESS_ALLOCATION_BY_OPERATING_STATUS:
      return {
        renderComponent: () => {
          return viewBy === VIEW_BY.TABLE ? (
            <BusinessStatusTable isDynamicReport />
          ) : (
            <BusinessStatusPieChart isDynamicReport />
          )
        },
        thunk: [
          ({ companyInfo }) =>
            getBusinessOperatingStatusTable({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: viewBy === VIEW_BY.TABLE,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.CHART],
        },
      }
    case PANELS.BUSINESS_ALLOCATION_BY_PROVINCE:
      return {
        renderComponent: () => {
          return viewBy === VIEW_BY.TABLE ? (
            <BusinessProvinceTable isDynamicReport />
          ) : (
            <BusinessProvinceMap />
          )
        },
        thunk: [
          ({ companyInfo }) =>
            getBusinessProvinceTable({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: viewBy === VIEW_BY.TABLE,
        settingPanel: {
          viewByList: [VIEW_BY.TABLE, VIEW_BY.MAP],
        },
      }
    case PANELS.INDUSTRY_SCALE:
      return {
        renderComponent: () => {
          return <IndustryScaleTable isDynamicReport />
        },
        thunk: [
          ({ companyInfo }) =>
            getIndustryScaleTable({
              organizationId: companyInfo.organizationId,
            }),
        ],
        isWaitForMount: true,
        isTable: true,
      }
    default:
      break
  }
}

export const getDefaultIndustryOverview = () => {
  const macroGDPTableState = selectMacroGDPTable(store.getState())
  const macroImportExportTableState = selectMacroImportExportTable(
    store.getState(),
  )
  const topIndustryPlayersState = selectTopIndustryPlayersState(
    store.getState(),
  )

  return getPanelListIndustryOverview()[0].children.map((panel) => ({
    id: getUnique(),
    ...panel,
    setting: getSetting(panel, {
      macroGDPTableState,
      macroImportExportTableState,
      topIndustryPlayersState,
    }),
  }))
}

const getSetting = (
  panel,
  { macroGDPTableState, macroImportExportTableState, topIndustryPlayersState },
) => {
  switch (panel?.panel) {
    case PANELS.MACROECONOMICS_GDP:
      return {
        ...panel.setting,
        isRealGDP: macroGDPTableState.tab === GDP_TAB.REAL_GDP.key,
      }

    case PANELS.MACROECONOMICS_IMPORT_EXPORT:
      return {
        ...panel.setting,
        isGrowthRate:
          macroImportExportTableState.tab ===
          IMPORT_EXPORT_TAB.GROWTH_RATE_PERCENT.key,
      }

    case PANELS.TOP_INDUSTRY_PLAYERS:
      return {
        ...panel.setting,
        top: topIndustryPlayersState?.topCompany?.value,
        fiscalYear: topIndustryPlayersState?.year?.value,
        isRankByTotalAssets:
          topIndustryPlayersState?.rankBy?.value === RANK_BY.totalAssets.value,
      }

    default:
      return panel.setting
  }
}

const RankByItem = (props) => {
  const companyType = useSelector(selectCompanyType)

  return (
    <ItemRadio
      {...props}
      title={
        companyType === COMPANY_TYPES.CORPORATE
          ? RANK_BY.netRevenue.corpLabel
          : RANK_BY.netRevenue.label
      }
    />
  )
}
